import axios from 'axios';
import _ from 'lodash';
import { routes, constants } from '../../constants/index.js';
import { parseJSONWithFallback } from '../../helpers/utils.js'

const { 
    SERVICE: { CAMPAIGNS_APP },
    ENDPOINTS: { 
        CAMPAIGNS:{ 
            GET_USER_DATA, 
            SAVE_USER_DATA, 
            DELETE_WEBGL_CONFIGURATION
        } 
    } 
} = routes;

const { 
    LOCAL_STORAGE_KEYS
} = constants;

const fetch = async (options) => {

    const {url, data, locale, token, method, throwError} = options;

    try {
        const request = await axios({
            method: method || 'GET',
            url,
            headers: { 
                'Content-Type': 'application/json',
                'x-tme-lc': locale,
                'x-tme-token': token
            },
            data: JSON.stringify(data)
        });
        
        return _.get(request, `data`, {});
    
    } catch (error) {
        
        if (throwError) {
            throw new Error(error) 
        } 
            
        return {};
    }        
};

const getUserData = async ({setUserPreferences, setWebglConfigurations, locale, token }) => {
    
    const url = `${CAMPAIGNS_APP}${GET_USER_DATA}`;
    const {configurations, preferences } = await fetch({url, locale, token});
    const artCollection = _.get(preferences, 'myArtCollection', [])
    const storedArtwork = parseJSONWithFallback(localStorage.getItem(LOCAL_STORAGE_KEYS.ARTWORK));
    const storedQuizResults = parseJSONWithFallback(localStorage.getItem(LOCAL_STORAGE_KEYS.QUIZ));
    
    if (!_.isEmpty(storedArtwork)) {
        artCollection.push(storedArtwork)
    }

    const userPreferences = {
        ...preferences,
        ...storedQuizResults,
        myArtCollection:artCollection
    }

    if (userPreferences) {
        setUserPreferences(userPreferences);
    }

    if (configurations) {
        setWebglConfigurations(configurations);
    }

    if(!_.isEmpty(storedArtwork) || !_.isEmpty(storedQuizResults)) {
        await saveUserData({payload:userPreferences, setUserPreferences, locale, token})
        localStorage.removeItem(LOCAL_STORAGE_KEYS.ARTWORK)
        localStorage.removeItem(LOCAL_STORAGE_KEYS.QUIZ)
    }

    return 
};

const saveUserData = async ({payload, setUserPreferences, locale, token}) => {

    const data = { payload };
    const url = `${CAMPAIGNS_APP}${SAVE_USER_DATA}`;
    const method = 'POST';
    await fetch({url, data, locale, method, token});

    setUserPreferences(payload);
};

const deleteWebGlCongfiguration = async ({id, locale, token }) => {
    const url = `${CAMPAIGNS_APP}${DELETE_WEBGL_CONFIGURATION}/${id}`;
    const method = 'DELETE';
    
    try {
        await fetch({url, locale, method, token, throwError:true});
    } catch(error) {
        throw (error)
    }
};

export {
    getUserData,
    saveUserData,
    deleteWebGlCongfiguration
}